import { useEffect, useState } from "react";

/**
 * Keeps something mounted for `exitMs` after `shown` turns false, so it can
 * animate out. `leaving` is true during that time.
 */
export const usePresence = (shown: boolean, exitMs: number) => {
  const [mounted, setMounted] = useState(shown);

  useEffect(() => {
    if (shown) {
      setMounted(true);
      return;
    }
    const timer = setTimeout(() => setMounted(false), exitMs);
    return () => clearTimeout(timer);
  }, [shown, exitMs]);

  return { mounted: shown || mounted, leaving: !shown && mounted };
};
